/**
 * @prettier
 * @flow
 */
export const KEY_NAME = 'environment';

export function getEnvironmentInLocaleStorage(): string {
    let item = window.localStorage.getItem('environment');
    return JSON.parse(item) ?? 'PROD';
}
